import { useAppDispatch } from "../../../../../redux/hooks";

import ActionMenu from "../../../../../components/actionMenu/ActionMenu";

import { DevicesNomenclatureListInterface } from "../../../../../redux/interfaces/admin.interface";
import { getDownloadDevice } from "../../../../../redux/api/admin.api";
import usePermissions from "../../../../../router/usePermissions";
import userRoles from "../../../../../constants/userRoles";

function DevicesNomenclatureHistoryActionButtons({
  itemId,
  crudData,
}: {
  itemId: string;
  crudData: DevicesNomenclatureListInterface;
}) {
  const dispatch = useAppDispatch();
  const { isAuthorized } = usePermissions();

  const handleDownloadDevice = async () => {
    if (itemId) {
      await dispatch(getDownloadDevice({ idDevice: itemId }));
    }
  };

  return (
    <ActionMenu
      minItemsForMenu={2}
      title={`${crudData.model} - ${crudData.sn}`}
      ariaLabel={`Actiuni pentru dispozitivul ${crudData.model} ${crudData.sn}`}
      items={[
        {
          id: "download",
          label: "Descarca document",
          icon: "DOWNLOAD",
          kind: "download",
          tooltip: !crudData.url
            ? "Aceasta inregistrare nu are un document atasat."
            : "Descarca documentul atasat dispozitivului.",
          hidden: !isAuthorized(userRoles.DEVICES_NOMENCLATURE_CREATE),
          disabled: !crudData.url,
          onClick: handleDownloadDevice,
        },
      ]}
    />
  );
}

export default DevicesNomenclatureHistoryActionButtons;
